// _components/site-header.js
import { LitElement, html, css, unsafeCSS } from 'lit';

const tailwindStyles = css`${unsafeCSS(COMPONENT_STYLES)}`;

class SiteHeader extends LitElement {
  static properties = {
    sitePath: { type: String },
    pageUrl: { type: String },
  };

  static styles = tailwindStyles;

  constructor() {
    super();
    this.sitePath = '/';
    this.pageUrl = '/';
    this.reedit = 'https://www.reddit.com/r/plusefin/';
    this.telegram = 'https://t.me/plusefin';
    this.isDashboardDomain = window.location.hostname === 'console.plusefin.com';
  }

  render() {
    return html`
      <header class="sticky top-0 z-50 w-full border-b border-[#e2d4c4] bg-[#fdfaf6]/90 backdrop-blur-xl">
        <div class="flex h-16 items-center ${this.isDashboardDomain ? 'px-8' : 'container'}">
          <a class="mr-6 flex items-center" href="${this.sitePath || '/'}">
            <img class="h-8 w-8" src="${this.sitePath}/favicon.svg" alt="PlusE logo" />
            <span class="ml-2 text-lg font-semibold tracking-tight text-[#241f1b]">PlusE</span>
          </a>
          <nav class="hidden items-center gap-6 text-sm md:flex">
            <a class="font-medium text-[#675c51] transition hover:text-[#241f1b]" href="${this.sitePath}/#data-layer">
              Data Layer
            </a>
            <a class="font-medium text-[#675c51] transition hover:text-[#241f1b] ${this.pageUrl.includes('/docs') ? '!text-[#241f1b]' : ''}" href="${this.sitePath}/docs">
              Docs
            </a>
            <a class="font-medium text-[#675c51] transition hover:text-[#241f1b] ${this.pageUrl.includes('/time-travel') ? '!text-[#241f1b]' : ''}" href="${this.sitePath}/time-travel">
              Time Travel
            </a>
            <a class="font-medium text-[#675c51] transition hover:text-[#241f1b]" href="${this.sitePath}/#pricing">
              Pricing
            </a>
          </nav>
          <div class="flex flex-1 items-center justify-end gap-3" id="account-actions">
            ${!this.isDashboardDomain ? html`
              <a href="https://console.plusefin.com/login" target="_blank" rel="noreferrer" class="inline-flex h-10 items-center justify-center rounded-full bg-[#241f1b] px-4 py-2 text-sm font-semibold text-[#fffaf2] shadow-sm transition hover:bg-[#3a332d] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#241f1b]/30">
                Console
              </a>
            ` : ''}
          </div>
        </div>
      </header>
    `;
  }
}

customElements.define('site-header', SiteHeader);
